import React, { type ReactNode } from 'react';

import { StyledSegment } from './styles';

export interface SegmentProps {
    children: ReactNode;
    minWidthTicks?: boolean;
}

export function Segment({ children, minWidthTicks = false }: SegmentProps) {
    return <StyledSegment $minWidthTicks={minWidthTicks}>{children}</StyledSegment>;
}
